<mat-card appearance="outlined" class="syn-card" fxLayout="column" fxLayoutAlign="space-around stretch" fxFlex="95" fxFlexOffset="3">
    <mat-card-header *ngIf="message">
        <mat-card-title>
            {{ message }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div>
            <mat-form-field fxFlex="33" appearance="outline">
                <mat-label>Filtrer</mat-label>
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filtrer">
                <button
                    mat-icon-button
                    matSuffix
                    (click)="applyFilter('', filter)"
                >
                    <mat-icon svgIcon="close"></mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-table #table [dataSource]="dataSource" matSort>

            <!-- id -->
            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-user-avatar [user]="row" [showId]="true" [size]="24"></syn-user-avatar>
                </mat-cell>
            </ng-container>

            <!-- user -->
            <ng-container matColumnDef="fullName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Utilisateur </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.firstName}} {{row.lastName}} </mat-cell>
            </ng-container>

            <!-- jobTitle -->
            <ng-container matColumnDef="job-title">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Profession </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.jobTitle}} </mat-cell>
            </ng-container>

            <!-- 27/7 -->
            <ng-container matColumnDef="is247">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="5"> 24/7 ? </mat-header-cell>
                <mat-cell *matCellDef="let row"fxFlex="5">
                    <mat-icon [ngClass]="{'syn-text--success' : row.is247, 'syn-text--danger': !row.is247 }" [svgIcon]="row.is247 ? 'check' : 'close'" class="ng-star-inserted" role="img" aria-hidden="true">

                    </mat-icon>
                </mat-cell>
            </ng-container>

            <!-- email -->
            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <a href="mailto:{{ row.email }}" class="syn-text--info">{{ row.email }}</a>
                </mat-cell>
            </ng-container>

            <!-- phone -->
            <ng-container matColumnDef="phone">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px" class="tel-cell">
                    <div *ngIf="row.mobilePhone" fxLayoutAlign="center">
                        <mat-icon  svgIcon="phone-outline"></mat-icon>
                        <span class="tel-label">Tél. mobile: {{row.mobilePhone}}</span>
                    </div>
                    <div *ngIf="row.workPhone" fxLayoutAlign="center">
                        <mat-icon  svgIcon="phone-outline"></mat-icon>
                        <span class="tel-label">Tél. fixe: {{row.workPhone}}</span>
                    </div>
                    <div *ngIf="row.companyPhone" fxLayoutAlign="center">
                        <mat-icon class="tel-icon" svgIcon="phone-outline"></mat-icon>
                        <span class="tel-label">Tél. standard: {{row.companyPhone}}</span>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <syn-dynamic-list-load-more *ngIf="displayLoadMore"
            [empty]="!users?.length"
            [active]="displayLoadMore"
            [textLoading]="'Chargement des utilisateurs en cours'"
            [textEmpty]="'Aucun utilisateur trouvé...'"
            [textLoadMore]="'Charger plus d\'utilisateurs'"
            (onLoadMore)="loadMore()">
        </syn-dynamic-list-load-more>
        <mat-paginator *ngIf="showPaginator && !displayLoadMore" #paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>

    </mat-card-content>
</mat-card>
